(() => {
  function initialise(scope = document) {
    scope.querySelectorAll('[data-c9-menu]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-menu-meat]')];
      const filters = [...root.querySelectorAll('[data-menu-filter]')];
      const expand = root.querySelector('[data-menu-expand]');
      let category = 'all', expanded = false;
      const matches = card => category === 'all' || card.dataset.menuMeat === category;
      filters.forEach(button => {
        const count = cards.filter(card => button.dataset.menuFilter === 'all' || card.dataset.menuMeat === button.dataset.menuFilter).length;
        const counter = button.querySelector('[data-category-count]'); if (counter) counter.textContent = count;
        button.hidden = button.dataset.menuFilter !== 'all' && count === 0;
        button.addEventListener('click', () => {
          category = button.dataset.menuFilter; expanded = false;
          filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          render();
          window.hugosTrack?.('carls_home_filter', { meat: category });
        });
      });
      function render() {
        let count = 0;
        cards.forEach(card => { const matching = matches(card); card.hidden = !matching || (!expanded && category === 'all' && count >= 4); if (matching) count++; });
        if (expand) expand.hidden = category !== 'all' || count <= 4;
        if (expand) expand.textContent = (expanded ? expand.dataset.less : expand.dataset.more).replaceAll('{count}', String(cards.length));
        expand?.setAttribute('aria-expanded', String(expanded));
      }
      expand?.addEventListener('click', () => { expanded = !expanded; render(); if (!expanded) root.querySelector('.c9-menu-tools').scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
      render();
    });
    scope.querySelectorAll('[data-c9-value]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const buttons = [...root.querySelectorAll('[data-value-size]')];
      buttons.forEach(button => button.addEventListener('click', () => {
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelector('[data-value-unit]').textContent = button.dataset.unit;
        root.querySelector('[data-value-total]').textContent = button.dataset.total;
        root.querySelector('[data-value-detail]').textContent = button.dataset.detail;
        root.querySelector('[data-value-cta]').dataset.startGoal = button.dataset.valueSize;
        const saving = root.querySelector('[data-value-saving]');
        if (saving) saving.hidden = button.dataset.valueSize !== '8';
        window.hugosTrack?.('carls_value_box_select', { pouches: Number(button.dataset.valueSize), servings: Number(button.dataset.valueSize) * 2 });
      }));
    });
  }
  window.CarlsCatalog?.hydrate();
  initialise();
  document.addEventListener('carls:catalog-ready', () => initialise());
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('keydown', event => {
    const toggle = document.querySelector('[data-menu-toggle]');
    if (event.key === 'Escape' && toggle?.getAttribute('aria-expanded') === 'true') { toggle.click(); toggle.focus(); }
  });
})();
